export default [
    {
        num: 1,
        key: 'draft',
        label: {
            en: 'Draft',
            et: 'Mustand',
            ru: 'Черновик',
            lv: "Melnraksts",
            lt: "Juodraštis",
            fi: "Luonnos",
        },
        // color: 'gray'
        color: 'black'
    },
    {
        num: 2,
        key: 'issued',
        label: {
            en: 'Issued',
            et: 'Väljastatud',
            ru: 'Выставлен',
            lv: "Izrakstīts",
            lt: "Išrašyta",
            fi: "Vahvistettu",
        },
        color: 'green'
    },
    {
        num: 3,
        key: 'paid',
        label: {
            en: 'Paid',
            et: 'Tasutud',
            ru: 'Оплачен',
            lv: "Apmaksāts",
            lt: "Apmokėta",
            fi: "Maksettu",
        },
        color: 'dark-blue'
    },
    {
        num: 4,
        key: 'payment_failed',
        label: {
            en: 'Payment Failed',
            et: 'Makse ebaõnnestus',
            ru: 'Ошибка оплаты',
            lv: "Maksājuma kļūda",
            lt: "Mokėjimo klaida",
            fi: "Maksu epäonnistui",
        },
        color: 'orange'
    },
    {
        num: 5,
        key: 'canceled',
        label: {
            en: 'Canceled',
            et: 'Tühistatud',
            ru: 'Отменён',
            lv: "Atcelts",
            lt: "Atšaukta",
            fi: "Peruttu",
        },
        color: 'red'
    },
    {
        num: 6,
        key: 'void',
        label: {
            en: 'Void',
            et: 'Annulleeritud',
            ru: 'Аннулирован',
            lv: "Anulēts",
            lt: "Anuliuota",
            fi: "Mitätöity",
        },
        // color: 'purple'
        color: 'yellow'
    },
    {
        num: 7,
        key: 'paid_partially',
        label: {
            en: 'Partially Paid',
            et: 'Osaliselt tasutud',
            ru: 'Оплачен частично',
            lv: "Daļēji apmaksāts",
            lt: "Iš dalies apmokėta",
            fi: "Osittain maksettu",
        },
        color: 'blue',
    },
    {
        num: 8,
        key: 'overpaid',
        label: {
            en: 'Overpaid',
            et: 'Enammakstud',
            ru: 'Переплачен',
            lv: "Pārmaksāts",
            lt: "Permokėta",
            fi: "Liikaa maksettu",
        },
        color: 'purple',
    },
]